import { render, staticRenderFns } from "./ManufacturerProductPerformance.vue?vue&type=template&id=65a5c82b&"
import script from "./ManufacturerProductPerformance.vue?vue&type=script&lang=js&"
export * from "./ManufacturerProductPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports